export var ifSetAndEnabled = function (p) { return function (fn) {
    if (p && p.enabled)
        fn(p);
}; };
export var forceSecure = function (endpoint) {
    if (/((https?):\/\/)(www\.)?[a-z0-9\-.]{3,}\.[a-z]{2,}$/.test(endpoint)) {
        return "https://" + endpoint.substring(endpoint.indexOf("://") + 3);
    }
    else {
        return "https://" + endpoint;
    }
};
export var getDomainUserId = function (cookieName) {
    var cn = cookieName || "_sp_";
    var matcher = new RegExp(cn + "id\\.[a-f0-9]+=([^;]+);?");
    var match = document.cookie.match(matcher);
    return match && match[1] ? match[1].split(".")[0] : null;
};
export var hashString = function (s) {
    var hash = 0, i, chr;
    if (s.length === 0)
        return hash;
    for (i = 0; i < s.length; i++) {
        chr = s.charCodeAt(i);
        hash = (hash << 5) - hash + chr;
        hash |= 0;
    }
    return hash;
};
